import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import LoaderGif from "../../Assets/AppComponent/Loadergif.webp";
export default function CircularIndeterminate() {
  return (
    <>
    <div 
    
 className="MainLoader"
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "200px",
          height: "175px",
          backgroundColor: "white",
          boxShadow: "#234492 0px 5px 15px",
          borderRadius: "3px",
          zIndex: 9999,
          position: "absolute",
          top: "37%",
          left: "42%",
        }}
      >
        <div>
          <p style={{ margin: 10, textAlign: "center", fontSize: "12px" }}>
            Loading...
          </p>
        </div>
        <CircularProgress
          sx={{
            width: "87px !important",
            height: "87px !important",
            margin: "auto",
            color: "#234492",
          }}
        />
      </Box>

      {/* <div className="" style={{width:"100px", height:"100px"}}>

        <img src={LoaderGif} style={{width:"100%", height:"100%"}}/>
      </div> */}
      </div>
    </>
  );
}
